import { render, staticRenderFns } from "./accurate.vue?vue&type=template&id=c6db794e&scoped=true&"
import script from "./accurate.vue?vue&type=script&lang=js&"
export * from "./accurate.vue?vue&type=script&lang=js&"
import style0 from "./accurate.vue?vue&type=style&index=0&id=c6db794e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6db794e",
  null
  
)

export default component.exports